<template>
    <!-- Bottom strip shared by the question (Activity) and feedback (Result)
         screens so both look exactly the same: team card on the left, event
         brand on the right.

         Class names on purpose: assets/scss/event-design.scss styles
         .activity-footer/.activity-jersey-card on .event-screen (the card
         sits inline in the footer there). Without it the card floats over
         the footer's top edge, so the scroll area above should leave some
         bottom padding (~6rem) for its last line to clear it. -->
    <div class="activity-footer">
        <div v-if="jersey_color" class="activity-jersey-card">
            <div class="activity-jersey-card-label">Equipo</div>
            <TeamJerseyBadge :color="jersey_color" :size="38" />
            <div class="activity-jersey-card-name">{{ username }}</div>
        </div>
        <EventBrand />
    </div>
</template>

<script>
import EventBrand from '@/components/EventBrand.vue'
import TeamJerseyBadge from '@/components/TeamJerseyBadge.vue'

export default {
    name: 'PlayerFooter',
    components: { EventBrand, TeamJerseyBadge },
    computed: {
        jersey_color(){
            const user = this.$store.state.game.user;
            return (user && user.avatar_style && user.avatar_style.color) || null;
        },
        username(){
            const user = this.$store.state.game.user;
            return user && user.username ? user.username.toUpperCase() : '';
        }
    }
}
</script>

<style scoped>
    .activity-footer{
        position: relative;
        display: flex;
        align-items: center;
        justify-content: flex-end;
        padding: 0.5rem 1.5rem;
        background-color: var(--vc-paper-50);
        border-top: 1px solid var(--vc-line);
        flex-shrink: 0;
    }

    .activity-jersey-card{
        position: absolute;
        left: 24px;
        bottom: calc(100% - 30px);
        z-index: 20;
        display: flex;
        flex-direction: column;
        align-items: center;
        padding: 10px 18px 14px;
        background-color: var(--vc-paper-50);
        border-radius: 16px;
        box-shadow: 0 8px 24px rgba(0, 0, 0, 0.18);
    }

    .activity-jersey-card-label{
        font-family: "Archivo", sans-serif;
        font-weight: 700;
        font-size: 0.65rem;
        text-transform: uppercase;
        letter-spacing: 0.08em;
        color: var(--vc-text-600);
        margin-bottom: 4px;
    }

    .activity-jersey-card-name{
        font-family: "Archivo", sans-serif;
        font-weight: 800;
        font-size: 0.8rem;
        color: var(--vc-ink-900);
        margin-top: 4px;
        max-width: 130px;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
    }

    @media (max-width: 480px){
        .activity-footer{
            padding: 0.4rem 1rem;
        }
        .activity-jersey-card{
            left: 8px;
            padding: 6px 12px 8px;
        }
        /* TeamJerseyBadge is always the card's 2nd child (label, badge,
           name) - scaling it structurally avoids reaching into its markup. */
        .activity-jersey-card > *:nth-child(2){
            transform: scale(0.8);
        }
        .activity-jersey-card-label{
            font-size: 0.55rem;
            margin-bottom: 2px;
        }
        .activity-jersey-card-name{
            font-size: 0.7rem;
            margin-top: 0;
            max-width: 90px;
        }
    }
</style>
